import { useEffect, useRef, useState } from 'react';

import {
  CHECKOUT_ELIGIBILITY_STATUS,
  fetchProviderSelfServeCheckoutEligibility,
} from '../../utils/serviceCalls/account';

/**
 * Gates Provider checkout for already-authenticated sessions (direct self-serve URL).
 * Eligible → ALLOWED; ineligible → hard-redirect to dashboard `fromSource=self-serve-failure`.
 *
 * @param {{ enabled: boolean, pwid?: string }} options
 * @returns {{ status: import('../../utils/serviceCalls/account').CheckoutEligibilityStatus }}
 */
export function useProviderCheckoutEligibility({ enabled, pwid }) {
  const [status, setStatus] = useState(() =>
    enabled
      ? CHECKOUT_ELIGIBILITY_STATUS.LOADING
      : CHECKOUT_ELIGIBILITY_STATUS.IDLE,
  );
  const redirectedRef = useRef(false);

  useEffect(() => {
    if (!enabled) {
      setStatus(CHECKOUT_ELIGIBILITY_STATUS.IDLE);
      redirectedRef.current = false;
      return undefined;
    }

    let cancelled = false;
    redirectedRef.current = false;
    setStatus(CHECKOUT_ELIGIBILITY_STATUS.LOADING);

    fetchProviderSelfServeCheckoutEligibility(pwid).then((result) => {
      if (cancelled) {
        return;
      }

      if (result?.eligible === true) {
        setStatus(CHECKOUT_ELIGIBILITY_STATUS.ALLOWED);
        return;
      }

      setStatus(CHECKOUT_ELIGIBILITY_STATUS.BLOCKED);

      const redirectUrl = result?.redirectUrl?.trim();
      if (!redirectUrl || redirectedRef.current) {
        return;
      }

      redirectedRef.current = true;
      window.location.href = redirectUrl;
    });

    return () => {
      cancelled = true;
    };
  }, [enabled, pwid]);

  return { status };
}
